<style src="./Landing.scss" lang="scss" scoped></style>

<template src="./Landing.html" />

<script>
import TopWave from '../TopWave/TopWave.vue';
import BottomWave from '../BottomWave/BottomWave.vue';
import Properties from '../Properties/Properties.vue';
import Membership from '../Membership/Membership.vue';
import SingingRiverRanch from '../../assets/fishing-1.jpg';
import BoulderRiverRanchImage from '../../assets/river-view-1.jpg';
import LincolnHills from '../../assets/fishing-5.jpg';
import HoldingFish from '../../assets/holding-fish.jpg';

export default {
  name: 'Landing',
  components: {
    TopWave,
    BottomWave,
    Properties,
    Membership,
  },
  data() {
    return {
      date: new Date().getFullYear(),
      membership: {
        title: '',
        image: HoldingFish,
        description: 'In order to preserve the moments quoted above, membership availability in the Lincoln Hills Fly Fishing Club is by invitation only and is strictly based on our members\' use of Club preserves, preserve acquisition, and our ability to maintain an atmosphere that our members enjoy. We maintain a strict ratio of members to amount of water ensuring a world class fly fishing experience at all of our Club preserves.',
      },
      properties: [
        {
          title: 'Lincoln Hills',
          image: LincolnHills,
          description: 'Our Home Water on South Boulder Creek has what many experts believe is the best fly fishing in Colorado. Complementing nearly two miles of private river is 5 acre Pactolus Lake and three spring fed ponds with gin clear water requiring delicate presentations to large wary trout. It is located just 45 minutes from downtown Denver, Colorado, and we guarantee it will be a catch and release experience of a lifetime.',
        },
        {
          title: 'Boulder River Ranch',
          image: BoulderRiverRanchImage,
          description: 'Boulder River Ranch is the downstream cousin of the Lincoln Hills Fly Fishing Club\'s home property. An excellent dry fly fishery, this one mile stretch of river is a wonderful place to catch a Grand Slam (rainbow, brown, cutthroat and brook trout) in a single day. The river is complemented with 5 ponds filled with large feisty trout that aggressively take terrestrials that find their way into the clear water.',
        },
        {
          title: 'Singing River Ranch',
          image: SingingRiverRanch,
          description: 'Running through a high mountain meadow, this preserve on Upper Bear Creek is truly one of the hidden gems of the Front Range consistently producing wild brown trout and the occasional 3-pound rainbow. Bear Creek, in its upper reaches has been private for as long as anyone can remember. Browns, rainbows and brook trout thrive in the cold clear water running off of Mount Evans. The riffles and cut banks of this meadow preserve are a dry fly angler\'s dream. Hoppers and large attractor dry flies are favorites of the trout that haunt these waters. At Singing River Ranch, the evening hatch is something you do not want to miss.',
        },
      ],
    };
  },
  methods: {
    routeToLH(event) {
      if (event) {
        window.location.href = 'https://www.theflyfisher.com/login/lincoln-hills-member';
      }
    },
  },
};
</script>
